import type { CreditHolidayRuleDB, AllCreditHolidayRulesResponse } from './@types/CreditHolidayRuleModel';
import type { WorkRule } from './@types/WorkRuleModel';
export class CreditHolidayRuleRepo {

    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getCreditHolidayRules(): Promise<CreditHolidayRuleDB[]> {
        try {
            const response = await this.httpService.get<AllCreditHolidayRulesResponse>('/credit_holiday_rules');
            return response.data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error("Error fetching credit holiday rules:", error);
            throw error;
        }
    }

    async getCreditHolidayRuleById(id: number): Promise<CreditHolidayRuleDB> {
        try {
            const response = await this.httpService.get<TKResponse<CreditHolidayRuleDB>>(`/credit_holiday_rules/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching credit holiday rule by ID:", error);
            throw error;
        }
    }

    async createCreditHolidayRule(data: CreditHolidayRuleDB): Promise<CreditHolidayRuleDB> {
        try {
            const response = await this.httpService.post<TKResponse<CreditHolidayRuleDB>, CreditHolidayRuleDB>('/credit_holiday_rules', { data });
            return response.data;
        } catch (error) {
            console.error("Error creating credit holiday rule:", error);
            throw error;
        }
    }

    async updateCreditHolidayRule(id: number, data: CreditHolidayRuleDB): Promise<CreditHolidayRuleDB> {
        try {
            const response = await this.httpService.put<TKResponse<CreditHolidayRuleDB>, CreditHolidayRuleDB>(`/credit_holiday_rules/${id}`, { data });
            return response.data;
        } catch (error) {
            console.error("Error updating credit holiday rule:", error);
            throw error;
        }
    }

    async deleteCreditHolidayRule(id: number): Promise<void> {
        try {
            return await this.httpService.delete<void>(`/credit_holiday_rules/${id}`);
        } catch (error) {
            console.error("Error deleting credit holiday rule:", error);
            throw error;
        }
    }

    async getWorkRules(): Promise<WorkRule[]> {
        try {
            const response = await this.httpService.get<TKResponse<WorkRule[]>>('/credit_holiday_rules/work_rules/by_columns');
            return response.data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error("Error fetching work rules:", error);
            throw error;
        }
    }

}
